@if (Vendor || ExemptVendor || ClientRegisteredVendor) {
  <div class="container-fluid">
    <div class="row">
      @if (Vendor) {
        <div class="col-4">
          <app-display-card [innerPanel]="true">
            <div class="row justify-content-center">
              <div class="col-auto">
                <label>Allow Duplicate Tax ID</label>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-auto">
                <p>
                  This allows another Vendor to register in VIVE with the same
                  tax ID (Typically necessary for enterprise Vendors).
                </p>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-auto">
                <button
                  class="btn btn-primary h-100"
                  (click)="duplicateTaxIdToggle()"
                >
                  {{ Vendor.allowDuplicateTaxId ? 'Disallow' : 'Allow' }}
                  duplicate tax ID
                </button>
              </div>
            </div>
          </app-display-card>
        </div>
      }
      <!--
      <div class="col-4">
        <app-display-card [innerPanel]="true">
          <div class="row justify-content-center">
            <div class="col-auto">
              <label>Archive Vendor</label>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-auto">
              <p>This operation will remove this Vendor from <span class="bold">ALL</span> Clients.</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-auto">
              <button class="btn btn-danger h-100" (click)="archiveVendor()">Archive vendor</button>
            </div>
          </div>
        </app-display-card>
      </div>
      -->
    </div>
  </div>
}
